import TtamOptimizationGoalVideoViewSelect from './video-view-select/index.vue';
import TtamOptimizationGoalDefaultSelect from './default-select/index.vue';
import TtamOptimizationGoalExplanationHint from './explanation-hint/index.vue';
import TtamOptimizationGoalCboSecondGoalTips from './cbo-second-goal-tips/index.vue';
import TtamOptimizationGoalCboNotSupportedTips from './cbo-not-supported-tips/index.vue';
import TtamOptimizationGoalAppTrackUrlTips from './app-track-url-tips/index.vue';
import TtamOptimizationGoalLabel from './label/index.vue';
import TtamOptimizationGoalLabelHint from './label-hint/index.vue';
import TtamOptimizationIos14DisabledHint from './ios14-disabled-hint/index.vue';

import * as hooks from './hooks';
export default {
  TtamOptimizationGoalVideoViewSelect,
  TtamOptimizationGoalDefaultSelect,
  TtamOptimizationGoalExplanationHint,
  TtamOptimizationGoalCboSecondGoalTips,
  TtamOptimizationGoalCboNotSupportedTips,
  TtamOptimizationGoalAppTrackUrlTips,
  TtamOptimizationGoalLabel,
  TtamOptimizationGoalLabelHint,
  TtamOptimizationIos14DisabledHint,
  ...hooks,
};
